import { reset, stopSubmit } from 'redux-form';
import { SET_PAYMENT_DATA, CREATE_PAYMENT_DATA, DELETE_PAYMENT_DATA,
  SET_PAYMENT_DATA_FOR_UPDATE, SET_UPDATED_PAYMENT_DATA } from '../constants/payment-data';
import userAPI from '../../_api/user';

const setPaymentData = (list) => ({ type: SET_PAYMENT_DATA, list });
const pushPaymentData = (item) => ({ type: CREATE_PAYMENT_DATA, item });
const removePaymentData = (id) => ({ type: DELETE_PAYMENT_DATA, id });
const setInitialValues = data => ({type: SET_PAYMENT_DATA_FOR_UPDATE, data});
const setUpdatedPaymentData = data => ({type: SET_UPDATED_PAYMENT_DATA, data});

export const getPaymentDataList = () => async (dispatch) => {
  const response = await userAPI.getPaymentDataList();
  if (response) dispatch(setPaymentData(response));
};

export const getMethodList = () => async (dispatch) => {
  const response = await userAPI.getPaymentDataMethods();
  if (response) return response;
};

export const createPaymentData = (payload) => async (dispatch) => {
  const response = await userAPI.createPaymentData(payload);
  if (response) {
    dispatch(pushPaymentData(response));
    dispatch(reset('paymentDataForm'));
    return true;
  }
};

export const deletePaymentData = (id) => async (dispatch) => {
  const response = await userAPI.deletePaymentData(id);
  if (response){
    dispatch(removePaymentData(id));
  }
};

export const getPaymentDataForUpdate = (id) => async (dispatch) => {
  try {
    const response = await userAPI.getPaymentData(id);
    if (response) {
      dispatch(setInitialValues(response));
    }
  } catch (e) {
    return { 'error': e.message }
  }
};

export const updatePaymentData = (id, payload) => async (dispatch) => {
  const response = await userAPI.updatePaymentData(id, payload);
  if (response) {
    dispatch(setUpdatedPaymentData(response));
    return true;
  }
};
